import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../config/useAxiosConfig";

const useData = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSchoolinfo = async (schoolId) => {
    try {
      const response = await axios.get(`/AdminSchoolsMember/${schoolId}`);
      if (response.data.success && response.data.rows.length > 0) {
        const schoolInfoData = response.data.rows[0];
        return schoolInfoData || {};
      } else {
        return {};
      }
    } catch (error) {
      console.error("Error fetching School Info data:", error);
      throw error;
    }
  };

  return {
    data,
    loading,
    error,
    fetchSchoolinfo,
  };
};

export default useData;
